//三选一礼包
TrinityGiftBagManager = xClass("TrinityGiftBagManager");
let _instance = null;
TrinityGiftBagManager.getInstance = function () {
    if (!_instance) {
        _instance = TrinityGiftBagManager.create();
    }
    return _instance;
}
TrinityGiftBagManager.prototype.ctor = function () {
    let self = this;
    self.info = {
        showEndTime: 0,//礼包曝光结束时间（值为0时表示不需要曝光）
        giftBagIds: [],//本次曝光的礼包编号列表（按低级礼包、中级礼包、高级礼包、打包礼包的顺序排列）
    };
    //
    self.fromToPanel = "main";
    self.dcData = {};//若entry=stage_end，session取值同关末失败界面曝光guideid
    self.buySucc = null;
    //
    UserLevel.getInstance().on(UserLevelEvent.LoseLevel, (event) => {
        self.addFailTimes(event.levelId);
    });
}

//获取活动信息
TrinityGiftBagManager.prototype.getInfo = function () {
    let self = this;
    return new Promise((resolve, reject) => {
        let onSuccess = function (evt) {
            if (evt && evt.data) {
                self.info = evt.data;
                resolve(evt.data);
            } else {
                reject(evt);
            }
        }

        let onFail = function (evt) {
            Toast.make(curryQuickGetErrorText(evt.data));
            reject(evt);
        }

        let http = TrinityGiftBagDetailHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load();
    })
}

//检查礼包购买条件
TrinityGiftBagManager.prototype.buyCheck = function (giftBagId) {
    let self = this;
    return new Promise((resolve, reject) => {
        let onSuccess = function (evt) {
            if (evt && evt.data) {
                resolve(evt.data);
            } else {
                reject(evt);
            }
        }

        let onFail = function (evt) {
            Toast.make(curryQuickGetErrorText(evt.data));
            reject(evt);
        }

        let http = TrinityGiftBagBuyCheckHttp.new();
        http.addEventListener(Events.kComplete, onSuccess);
        http.addEventListener(Events.kError, onFail);
        http.addEventListener(Events.kCancel, onFail);
        http.load(giftBagId);
    })
}

/** 活动是否开启，包括未开启状态/待结算状态 */
TrinityGiftBagManager.prototype.isOpen = function () {
    let self = this;
    if (self.isConfigOpen()) {
        let info = self.info;
        if (self.commonCfg && info) {
            const nowTime = Localhost.time();
            if (info.giftBagIds && $len(info.giftBagIds) && nowTime < info.showEndTime) {
                return true;
            }
        }
    }
    return false;
}

TrinityGiftBagManager.prototype.isConfigOpen = function () {
    let self = this;
    if (cc.sys.os === cc.sys.OS_IOS && !UserManager.getInstance().canIosToMiniPay()) {
        return false;
    }
    if (_G.kUserLogin && UserManager.getInstance().canIconShow(addPfSuffix("trinity_gift_bag"))) {
        return true;
    }
    return false;
}


/** 获取大厅中的功能icon */
TrinityGiftBagManager.prototype.getSceneIcon = function () {
    let btnLayer = require("clover/scene/HomeScene").getInstance().btnLayer;
    return btnLayer.TrinityGiftBagBtn;
}

/** 打开面板 - 主页面 */
TrinityGiftBagManager.prototype.openPanel = function (cb, cbClose) {
    let self = this;
    const TrinityGiftBagPanel = require("./TrinityGiftBagPanel");
    function onResLoad() {
        let panel = TrinityGiftBagPanel.create();
        panel.on(BasePanelEvent.Close, function () {
            cbClose && cbClose();
        });
        cb && cb(panel);
    }

    function onResLoadFail(evt) {
        cc.log("unable to create TrinityGiftBagPanel. load res failed.", evt);
        cb && cb();
    }
    TrinityGiftBagPanel.preloadRes(onResLoad, onResLoadFail, onResLoadFail, true);
}

TrinityGiftBagManager.prototype.getRewardById = function (id) {
    let self = this;
    if (id && self.rewardCfg) {
        return self.rewardCfg[id];
    }
    return null;
}

TrinityGiftBagManager.prototype.clickBuyGoods = function (giftBagId, dcData, cb) {
    let self = this;
    self.buyCheck(giftBagId).then((data) => {
        if (data.checkFlag) {
            //
            function onSuccess() {
                Toast.make(getText("payment.tip.success"), 0.5);
                cb && cb(true);
                self.triggerBuySucc(true);
                self.info.showEndTime = 0;
            }

            function onFail() {
                Toast.make(getText("payment.tip.failure"), 0.5);
                cb && cb(false);
            }

            function onCancel() {
                Toast.make(getText("payment.tip.cancel"), 0.5);
                cb && cb(false);
            }
            //
            let cfg = self.getRewardById(giftBagId);
            dcData.price = cfg.price;
            dcData.goodsId = giftBagId;
            //
            let extProductId = ""
            let plaform = XcloverPlatform.huawei;
            let arr = cfg.productId.split(",")
            for (let i = 0; i < arr.length; i++) {
                let conf = arr[i]
                let arr1 = conf.split(":")
                if (arr1[0] == plaform) {
                    extProductId = arr1[1]
                    break
                }
            }
            dcData.extProductId = extProductId;
            dcData.ext = { trinityGiftBagId: giftBagId };
            UserProduct.getInstance().buyProduct(giftBagId, onSuccess, onFail, onCancel, ModuleName.TRINITY_GIFT_BAG, dcData);
        } else {
            Toast.make(getText("trinity_gift_bag_check_error"));
            //
            self.getInfo().then(() => {
                cb && cb(false);
            }).catch((err) => {
                console.error("clickBuyGoods - buyCheck", err);
                cb && cb(false);
            })
        }
    }).catch((err) => {
        console.error("clickBuyGoods", err);
        cb && cb(false);
    })
}

TrinityGiftBagManager.prototype.isTrinityGiftBag = function (id) {
    return !isNaN(id) && id >= 17001 && id <= 17999;
}

TrinityGiftBagManager.prototype.loadConfig = function () {
    let self = this;
    if (self.commonCfg) {
        return Promise.resolve();
    } else {
        return new Promise((resolve, reject) => {
            CfgManager.load("trinity_gift_bag_option", "trinity_gift_bag").then(() => {
                self.commonCfg = CfgManager.get("trinity_gift_bag_option");
                self.rewardCfg = CfgManager.get("trinity_gift_bag");
                resolve();
                CfgManager.release("trinity_gift_bag_option", "trinity_gift_bag");
            }).catch(() => reject())
        });
    }
}

//当期累计失败N次时曝光
TrinityGiftBagManager.prototype.addFailTimes = function (levelId) {
    let self = this;
    if (self.isOpen()) {
        let temp = self.getStorage();
        let failLevel = temp.failLevel || {};
        if (!failLevel[levelId]) {
            failLevel[levelId] = 1;
        } else {
            failLevel[levelId]++;
        }
        cc.UserDefault.getInstance().setStringForKey(STORAGE_KEY, JSON.stringify(temp));
    }
}
const STORAGE_KEY = "TrinityGiftBag";
TrinityGiftBagManager.prototype.addShowTimes = function () {
    let self = this;
    if (self.isOpen()) {
        let temp = self.getStorage();
        temp.showTimes++;
        cc.UserDefault.getInstance().setStringForKey(STORAGE_KEY, JSON.stringify(temp));
    }
}
//是否可以展示关末礼包
TrinityGiftBagManager.prototype.checkShowGift = function (levelId) {
    let self = this;
    if (self.isOpen()) {
        let temp = self.getStorage();
        let failLevel = temp.failLevel;
        if (!failLevel || !failLevel[levelId] || failLevel[levelId] < self.commonCfg.fail_times) return false;
        //
        if (temp.showTimes < self.commonCfg.show_limit_times) {
            return true;
        }
    }
    return false;
}

//buySucc: 礼包关闭和倒计时结束等也会调用该方法
TrinityGiftBagManager.prototype.showFailView = function (dcData, cb, buySucc) {
    let self = this;

    const TrinityGiftBagView = require("./TrinityGiftBagView");
    function onResLoad() {
        self.dcData = dcData;
        let panel = TrinityGiftBagView.create(dcData);
        self.buySucc = buySucc;
        cb && cb(panel);
        self.addShowTimes();
    }

    function onResLoadFail(evt) {
        cc.log("unable to create TrinityGiftBagView. load res failed.", evt);
        cb && cb();
    }
    TrinityGiftBagView.preloadRes(onResLoad, onResLoadFail, onResLoadFail, true);
}

TrinityGiftBagManager.prototype.triggerBuySucc = function (succ) {
    let self = this;
    if (self.buySucc) {
        self.buySucc(succ);
        self.buySucc = null;
    }
}

TrinityGiftBagManager.prototype.getStorage = function () {
    let self = this;
    const flag = self.info.showEndTime;
    let data = {
        flag,//期数
        failLevel: {},//失败次数
        showTimes: 0,//展示次数
    };
    let str = cc.UserDefault.getInstance().getStringForKey(STORAGE_KEY);
    if (str) {
        let temp = JSON.parse(str);
        if (temp.flag == flag) {
            data = temp;
        }
    }
    return data;
}

TrinityGiftBagManager.prototype.dcSimple = function (subCategory, params = {}, category) {
    let self = this;
    if (!params.session) {
        params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    }
    DCAssist.userTrack(category ? category : ModuleName.TRINITY_GIFT_BAG, subCategory, params);
    return params;
}